import axios from 'axios';
import qs from 'qs';

const URL = "https://abrightspot.org/wp-admin/admin-ajax.php";
function getAirData(args) {
	const safeArgs = qs.stringify(args);
	return axios.post(URL, safeArgs).then(response => response.data);
}

export {URL, getAirData};